"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonAppShell = void 0;
const react_1 = __importStar(require("react"));
const Header_1 = require("../../components/Header");
const Sidebar_1 = require("../../components/Sidebar");
const navigation_1 = require("./navigation");
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonAppShell = ({ menu, children, onLogout, onProfile, onInvoices, onChangeBranch, onSettings, pathname: pathnameProp, onNavigate }) => {
    const { navigation, theme } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const resolvedMenu = menu || (0, navigation_1.toShellNavigation)(navigation);
    const pathname = pathnameProp !== null && pathnameProp !== void 0 ? pathnameProp : (typeof window !== 'undefined' ? window.location.pathname : '/');
    const [sidebarOpen, setSidebarOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => setSidebarOpen(false), [pathname]);
    return react_1.default.createElement("div", { style: { minHeight: '100vh', display: 'flex', flexDirection: 'column', background: theme === 'dark' ? '#111827' : '#F7FAFC', color: theme === 'dark' ? '#F7FAFC' : '#2D3748' } },
        react_1.default.createElement(Header_1.OktonHeader, { onOpenSidebar: () => setSidebarOpen(true), onLogout: onLogout, onProfile: onProfile, onInvoices: onInvoices, onChangeBranch: onChangeBranch, onSettings: onSettings }),
        react_1.default.createElement("div", { style: { flex: 1, minHeight: 0, display: 'flex' } },
            react_1.default.createElement(Sidebar_1.OktonSidebar, { sections: resolvedMenu, isOpen: sidebarOpen, onClose: () => setSidebarOpen(false), pathname: pathname, onNavigate: onNavigate }),
            react_1.default.createElement("main", { style: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' } }, children)));
};
exports.OktonAppShell = OktonAppShell;
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map